import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const UserBaggageIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M20.4167 22.0417V19.6111C20.4167 18.3219 19.9558 17.0854 19.1353 16.1738C18.3148 15.2622 17.202 14.75 16.0417 14.75H7.29169C6.13137 14.75 5.01857 15.2622 4.19809 16.1738C3.37762 17.0854 2.91669 18.3219 2.91669 19.6111V22.0417"
      stroke="#C1B1AC"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 10.375C14.0829 10.375 16.0417 8.41625 16.0417 6C16.0417 3.58375 14.0829 1.625 11.6667 1.625C9.25044 1.625 7.29169 3.58375 7.29169 6C7.29169 8.41625 9.25044 10.375 11.6667 10.375Z"
      stroke="#C1B1AC"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.5828 25.6399V24.875H26.3598C26.812 24.875 27.2465 24.6972 27.5676 24.3792C27.8888 24.0611 28.0702 23.6287 28.0702 23.1768V12.0928C28.0702 11.641 27.8888 11.2085 27.5676 10.8904C27.2465 10.5724 26.812 10.3946 26.3598 10.3946H24.961V9.01395C24.961 8.39876 24.7141 7.8097 24.2763 7.3761C23.8385 6.94265 23.2458 6.69996 22.6288 6.69996H20.1414C19.5243 6.69996 18.9316 6.94265 18.4939 7.3761C18.0561 7.8097 17.8092 8.39876 17.8092 9.01395V10.3946H16.4104C15.9582 10.3946 15.5237 10.5724 15.2026 10.8904C14.8813 11.2085 14.7 11.641 14.7 12.0928V23.1768C14.7 23.6287 14.8813 24.0611 15.2026 24.3792C15.5237 24.6972 15.9582 24.875 16.4104 24.875H17.1874V25.6399C17.1874 25.9285 17.3032 26.2043 17.5078 26.4069C17.7123 26.6094 17.9887 26.7223 18.2759 26.7223C18.5631 26.7223 18.8395 26.6094 19.044 26.4069C19.2486 26.2043 19.3644 25.9285 19.3644 25.6399V24.875H23.4058V25.6399C23.4058 25.9285 23.5216 26.2043 23.7262 26.4069L24.0546 26.0753L23.7262 26.4069C23.9307 26.6094 24.2071 26.7223 24.4943 26.7223C24.7815 26.7223 25.0579 26.6094 25.2624 26.4069C25.467 26.2043 25.5828 25.9285 25.5828 25.6399ZM22.7839 10.3946H19.9862V9.01395C19.9862 8.97589 20.0015 8.93845 20.0301 8.91013C20.0588 8.88165 20.0988 8.86484 20.1414 8.86484H22.6288C22.6714 8.86484 22.7114 8.88165 22.7401 8.91013C22.7687 8.93845 22.7839 8.97589 22.7839 9.01395V10.3946Z"
      fill="#C1B1AC"
      stroke="white"
      strokeWidth="0.933333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5218 21.3294V13.9401C19.5218 13.7768 19.4563 13.6202 19.3397 13.5047C19.2231 13.3892 19.0649 13.3243 18.9 13.3243C18.7351 13.3243 18.5769 13.3892 18.4603 13.5047C18.3437 13.6202 18.2781 13.7768 18.2781 13.9401V21.3294C18.2781 21.4927 18.3437 21.6494 18.4603 21.7648C18.5769 21.8803 18.7351 21.9452 18.9 21.9452C19.0649 21.9452 19.2231 21.8803 19.3397 21.7648C19.4563 21.6494 19.5218 21.4927 19.5218 21.3294Z"
      fill="white"
    />
    <path
      d="M20.9476 13.5047C21.0642 13.3892 21.2224 13.3243 21.3873 13.3243C21.5523 13.3243 21.7104 13.3892 21.827 13.5047C21.9437 13.6202 22.0092 13.7768 22.0092 13.9401V21.3294C22.0092 21.4927 21.9437 21.6494 21.827 21.7648C21.7104 21.8803 21.5523 21.9452 21.3873 21.9452C21.2224 21.9452 21.0642 21.8803 20.9476 21.7648C20.831 21.6494 20.7655 21.4927 20.7655 21.3294V13.9401C20.7655 13.7768 20.831 13.6202 20.9476 13.5047Z"
      fill="white"
    />
    <path
      d="M23.435 13.5047C23.5516 13.3892 23.7098 13.3243 23.8747 13.3243C24.0396 13.3243 24.1978 13.3892 24.3144 13.5047C24.431 13.6202 24.4965 13.7768 24.4965 13.9401V21.3294C24.4965 21.4927 24.431 21.6494 24.3144 21.7648C24.1978 21.8803 24.0396 21.9452 23.8747 21.9452C23.7098 21.9452 23.5516 21.8803 23.435 21.7648C23.3184 21.6494 23.2529 21.4927 23.2529 21.3294V13.9401C23.2529 13.7768 23.3184 13.6202 23.435 13.5047Z"
      fill="white"
    />
  </svg>
));
